import { render, staticRenderFns } from "./UploadInfoComponent.vue?vue&type=template&id=5ff77429"
import script from "./UploadInfoComponent.vue?vue&type=script&lang=js"
export * from "./UploadInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadInfoComponent.vue?vue&type=style&index=0&id=5ff77429&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports